import { connect } from 'react-redux';
import * as DebtsStore from '../../../redux/middleware/CashFlow-Debts.Middleware';
import { Debt } from '../../../models/Entities/CashFlow/Debt/Debt';
import { ErrorType } from '../../../models/HttpError';
import { DebtPaymentImputation } from '../../../models/Entities/CashFlow/Payment/DebtPaymentImputation';
import { Person } from '../../../models/Entities/Person/Person';
import { AppState } from '../../../redux/reducers';

// Define the state props from Redux
interface StateProps {
    debts: Debt[];
    isLoading: boolean;
    error: ErrorType | undefined;
}

// Define the dispatch props from Redux
interface DispatchProps {
    GetAllDebtsByDebtor: typeof DebtsStore.actionCreators.GetAllDebtsByDebtor;
}

// Define the component's own props
export interface OwnProps {
    debtor: Person;
    creditor?: Person;
    paymentCurrency: string;
    paymentAmount: number;
    onImputationsChange: (imputations: DebtPaymentImputation[]) => void;
    selectedImputations?: DebtPaymentImputation[];
}

// Combined props type
export type Props = StateProps & DispatchProps & OwnProps;

// Map Redux state to component props
export const mapStateToProps = (state: AppState): StateProps => ({
    debts: state.CashFlowDebts?.DebtsAsDebtor || [],
    isLoading: state.CashFlowDebts?.isLoadingAll || false,
    error: state.CashFlowDebts?.error
});

// Map Redux dispatch actions to component props
export const mapDispatchToProps = {
    GetAllDebtsByDebtor: DebtsStore.actionCreators.GetAllDebtsByDebtor
};
